import { render } from "./CarnetView.vue?vue&type=template&id=f1fb8cac&scoped=true"
import script from "./CarnetView.vue?vue&type=script&lang=js"
export * from "./CarnetView.vue?vue&type=script&lang=js"

import "./CarnetView.vue?vue&type=style&index=0&id=f1fb8cac&scoped=true&lang=css"
/* custom blocks */
import block0 from "./CarnetView.vue?vue&type=custom&index=0&blockType=v-snackbar&color=success"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1fb8cac"]])

export default __exports__